import { render } from "./DxtAccountStatistics.vue?vue&type=template&id=f56b0fd4&scoped=true"
import script from "./DxtAccountStatistics.vue?vue&type=script&lang=js"
export * from "./DxtAccountStatistics.vue?vue&type=script&lang=js"

import "./DxtAccountStatistics.vue?vue&type=style&index=0&id=f56b0fd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f56b0fd4"

export default script